import { PaymentType } from '@kinet-open-network/client/payment-types/data-access';

export class AppPaymentType extends PaymentType {}
